// extracted by mini-css-extract-plugin
export default {"root":"Done_root__uy5he","ok":"Done_ok__Op1tq","title":"Done_title__w7YeA","desc":"Done_desc__Sujg1","link":"Done_link__51nFP"};